// Module
var code = "<div class=\"action-menu form-field-selector-popover\" style=\"width:400px;height:340px\" role=\"dialog\"> <component @click.stop :is=\"getContactDataRestrictionType(selectedType)\" :type.sync=\"selectedType\" :form=\"form\" @done=\"done\"> </component> </div> ";
// Exports
export default code;